import { render } from "./LeaveBalances.vue?vue&type=template&id=50ce2bac"
import script from "./LeaveBalances.vue?vue&type=script&lang=js"
export * from "./LeaveBalances.vue?vue&type=script&lang=js"

import "./LeaveBalances.vue?vue&type=style&index=0&id=50ce2bac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__